var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOverviewKey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "overview_key_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#overview_key_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.001 12.665c-.366 0-.68-.13-.941-.391a1.284 1.284 0 0 1-.392-.942V4.665c0-.366.13-.68.392-.941.26-.261.575-.392.941-.392h6.667c.367 0 .68.13.942.392.26.26.391.575.391.941v6.667c0 .367-.13.68-.391.942a1.284 1.284 0 0 1-.942.391H2.001Zm0-1.333h6.667V4.665H2.001v6.667Zm10 1.333a.645.645 0 0 1-.475-.191.645.645 0 0 1-.191-.475v-8c0-.19.063-.348.191-.475a.645.645 0 0 1 .475-.192c.19 0 .348.064.475.192a.645.645 0 0 1 .192.475v8a.645.645 0 0 1-.192.475.645.645 0 0 1-.475.191Zm2.667 0a.645.645 0 0 1-.475-.191.645.645 0 0 1-.192-.475v-8c0-.19.064-.348.192-.475a.645.645 0 0 1 .475-.192c.189 0 .347.064.475.192a.645.645 0 0 1 .192.475v8a.645.645 0 0 1-.192.475.645.645 0 0 1-.475.191Z"
}))));
export default SvgOverviewKey;